import React, { useState } from 'react'
import { Button } from '@material-ui/core'
import './Dashboard.css'
import DashboardLayout from './DashboardLayout'
import Popup from '../../custom/components/organisms/Popup'
import CustomInput from '../../product/components/atoms/Inputs/CustomInput'
import PrimaryButton from '../../product/components/atoms/PrimaryButton'
import { mapData } from '../../product/common/components'
import { useFormik } from 'formik'

const SavedCard = (props) => {
    const [addCard, setAddCard] = useState(false)
    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
            confirm_password: '',
        },
    })
    const addCardData = [
        {
            label: 'Name',
            name: 'name',
            type: 'email',
            placeholder: 'Enter Card Holder Name',
            class: 'col-12',
            autoFocus: true,
            formik: formik,
        },
        {
            label: 'Card Number',
            name: 'card_number',
            type: 'number',
            placeholder: 'Enter Card Number',
            class: 'col-12',
            formik: formik,
        },
        {
            label: 'Name',
            name: 'name',
            type: 'email',
            placeholder: 'Enter Card Holder Name',
            class: 'col-12',
            autoFocus: true,
            formik: formik,
        },
        {
            label: 'CVV',
            name: 'cvv',
            type: 'text',
            placeholder: 'Enter' + ' CVV',
            class: 'col-12',
            formik: formik,
        },
        {
            label: 'Expiry Date',
            name: 'expiry_date',
            type: 'date',
            placeholder: 'Date of Card Expiration',
            class: 'col-12',
            formik: formik,
        },
    ]

    return (
        <DashboardLayout title={'Saved Cards'}>
            <div className="dashboardInner mySavedCards">
                <div className="emptySavedCard" onClick={() => setAddCard(true)}>
                    <img src="./assets/svg/cardIcon.svg" alt="Card icon" />
                    <h4>{'Add a New Card'}</h4>
                </div>
                <div className="filledSavedCard">
                    <div className="row">
                        <div className="col-6 text-left">
                            <a
                                href="#"
                                className="modifyCard edit"
                                onClick={() => setAddCard(true)}
                            >
                                <span className="material-icons">edit</span>
                            </a>
                            <a href="#" className="modifyCard delete">
                                <span className="material-icons">delete</span>
                            </a>
                        </div>
                        <div className="col-6 pt-1 text-right">
                            <img src="/assets/svg/visa-pay-logo.svg" alt="bank" />
                        </div>
                    </div>
                    <div className="card-num">
                        <span>****</span>
                        <span>****</span>
                        <span>****</span>
                        <span>4051</span>
                    </div>
                    <div className="clearfix">
                        <div className="float-left">
                            <div className="fs-12">{'Card Holder'}</div>
                            <div className="fs-12">test</div>
                        </div>
                        <div className="float-right">
                            <div className="fs-12">{'Expires'}</div>
                            <div className="fs-12">12 / 24</div>
                        </div>
                    </div>
                </div>
                <Popup
                    open={addCard}
                    size="md"
                    handleClose={() => setAddCard(false)}
                    modaltitle={'Add a New Card'}
                >
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row">{Object.values(mapData(addCardData))}</div>
                        <div className="row">
                            <div className="col-12 text-center">
                                <PrimaryButton label={'Save'} />
                            </div>
                        </div>
                    </form>
                </Popup>
            </div>
        </DashboardLayout>
    )
}

export default SavedCard
